import { useLocalStorage } from './useLocalStorage';
import { TaxiStand } from '../types';

export function useFavoriteTaxiStands() {
  const [favorites, setFavorites] = useLocalStorage<TaxiStand[]>('favoriteTaxiStands', []);

  const addFavorite = (stand: TaxiStand) => {
    setFavorites(prev => {
      if (prev.some(f => f.id === stand.id)) return prev;
      return [...prev, stand];
    });
  };

  const removeFavorite = (standId: number) => {
    setFavorites(prev => prev.filter(f => f.id !== standId));
  };

  const isFavorite = (standId: number) => {
    return favorites.some(f => f.id === standId);
  };

  return {
    favorites,
    addFavorite,
    removeFavorite,
    isFavorite
  };
}